export const inputRules = {
  required: v => (!!v && (typeof v !== 'string' || !!v.trim())) || v === 0 || 'Trường bắt buộc',
  maxLength: length => v => (v && v.length <= length) || !v || `Độ dài tối đa ${length} ký tự`,
  minLength: length => v => (v && v.length >= length) || !v || `Minium ${length} ký tự`,
  maxArrayLength: length => v => (v && v.length <= length) || !v || `Tối đa ${length} đối tượng`,
  minArrayLength: length => v => (v && v.length >= length) || !v || `Tối thiểu ${length} đối tượng`,
  max: number => v => {
    if (v === null || v === undefined) {
      return true
    }
    if (typeof v === 'string') {
      if (!v) {
        return true
      }
      v = parseFloat(v)
    }
    if (isNaN(v)) {
      return 'Phải là số'
    }
    const res = v <= number || `Giá trị tối đa là ${number}`
    return res
  },
  min: number => v => {
    if (v === null || v === undefined) {
      return true
    }

    if (typeof v === 'string') {
      if (!v) {
        return true
      }
      v = parseFloat(v)
    }
    if (isNaN(v)) {
      return 'Phải là số'
    }
    const res = v >= number || `Giá trị tối thiểu là ${number}`
    return res
  },
  email: v =>
    (v &&
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        v.trim()
      )) ||
    !v ||
    'Định dạng Email không đúng',
  url: v => {
    return (
      /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(
        v
      ) ||
      !v ||
      'URL không hợp lệ'
    )
  },
  alphabet: v =>
    !v ||
    /^[a-z ẮẰẲẴẶĂẤẦẨẪẬÂÁÀÃẢẠĐẾỀỂỄỆÊÉÈẺẼẸÍÌỈĨỊỐỒỔỖỘÔỚỜỞỠỢƠÓÒÕỎỌỨỪỬỮỰƯÚÙỦŨỤÝỲỶỸỴ]+$/gi.test(
      v.trim()
    ) ||
    'Chỉ bao gồm chữ cái',
  normal: v =>
    !v ||
    /^[a-z0-9 ._ẮẰẲẴẶĂẤẦẨẪẬÂÁÀÃẢẠĐẾỀỂỄỆÊÉÈẺẼẸÍÌỈĨỊỐỒỔỖỘÔỚỜỞỠỢƠÓÒÕỎỌỨỪỬỮỰƯÚÙỦŨỤÝỲỶỸỴ]+$/gi.test(
      v.trim()
    ) ||
    'Ký tự không hợp lệ',
  equal: (target, msg) => v => !v || target === v || msg || `Giá trị phải là ${target}`,
  phone: v =>
    !v ||
    (v.length >= 10 && /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/gi.test(v)) ||
    'Invalid phone number',
  nospace: v => !v || !/ /.test(v.trim()) || 'Không được chứa khoảng trắng',
  notEmpty: v => !Array.isArray(v) || !!v.length || 'Không được để trống'
}
